import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles(({ breakpoints }) => ({
  card: {
    margin: 'auto',
    height: '100%'
  },
  // From lg the four columns are ~288px. The card fills its column so the
  // gap is the grid's 16px, as on the home Featured row, rather than 16px
  // plus the slack around a 282px card. Applied only with four columns (see
  // list.js): narrower breakpoints, and the three columns a campaign banner
  // leaves (~389px), run wider and would stretch the 180px-tall image.
  fillColumn: {
    [breakpoints.up('lg')]: {
      '&&': { maxWidth: 'none' }
    }
  }
}))
